var AdaptiveImage = require("../../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js").default;

module.exports = new AdaptiveImage({
    uri: __webpack_public_path__ + "icon-app-settings.636f30f1.png","uri@2x": __webpack_public_path__ + "icon-app-settings.2431bebc.png","uri@3x": __webpack_public_path__ + "icon-app-settings.325a34d4.png",
    width: 20,
    height: 20
});